(function () {
  function initMultibuyOffer(offer) {
    if (!offer || offer.dataset.multibuyInitialized === 'true') return;

    if (!offer.closest('form')) return;

    updatePrices(offer);
    offer.dataset.multibuyInitialized = 'true';
  }

  function handleOptionClick(event) {
    if (!(event.target instanceof Element)) return;

    const option = event.target.closest('[data-multibuy-option]');
    const offer = option?.closest('[data-multibuy-offer]');
    const productForm = offer?.closest('form');
    if (!option || !offer || !productForm) return;

    offer.querySelectorAll('[data-multibuy-option]').forEach((currentOption) => {
      const isSelected = currentOption === option;
      currentOption.classList.toggle('is-active', isSelected);
      currentOption.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    const quantityInput = getQuantityInput(productForm);
    quantityInput.value = option.dataset.quantity || '1';
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleVariantChange(event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches('[data-hidden-variant-input]')) return;

    const offer = event.target.closest('form')?.querySelector('[data-multibuy-offer]');
    if (offer) updatePrices(offer);
  }

  function getQuantityInput(productForm) {
    let quantityInput = productForm.querySelector('input[name="quantity"]');
    if (quantityInput) return quantityInput;

    quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';
    productForm.appendChild(quantityInput);
    return quantityInput;
  }

  function updatePrices(offer) {
    const productForm = offer.closest('form');
    const variantInput = productForm?.querySelector('[data-hidden-variant-input]');
    const variantData = getVariantData(offer);
    const currentVariantId = Number(variantInput?.value);
    const currentVariant = variantData.find((variant) => variant.id === currentVariantId) || variantData[0];

    if (!currentVariant || typeof currentVariant.price !== 'number') return;

    const singlePrice = currentVariant.price;

    offer.querySelectorAll('[data-multibuy-option]').forEach((option) => {
      const quantity = Number(option.dataset.quantity || 1);
      const discountPercent = Number(option.dataset.discountPercent || 0);
      const regularPrice = singlePrice * quantity;
      const discountedUnitPrice = Math.round(singlePrice * (100 - discountPercent) / 100);
      const offerPrice = discountedUnitPrice * quantity;
      const savings = regularPrice - offerPrice;

      updateText(option, '[data-multibuy-option-price]', formatMoney(offer, offerPrice));
      updateText(option, '[data-multibuy-discount]', String(discountPercent));
      updateText(option, '[data-multibuy-savings]', formatMoney(offer, savings));
    });
  }

  function getVariantData(offer) {
    const script = offer.querySelector('[data-multibuy-variants]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function updateText(offer, selector, value) {
    const element = offer.querySelector(selector);
    if (element) element.textContent = value;
  }

  function formatMoney(offer, cents) {
    const locale = offer.dataset.locale || document.documentElement.lang || 'en';
    const currency = offer.dataset.currency || 'EUR';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(cents / 100);
  }

  function initAllMultibuyOffers() {
    document.querySelectorAll('[data-multibuy-offer]').forEach(initMultibuyOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMultibuyOffers);
  } else {
    initAllMultibuyOffers();
  }

  document.addEventListener('shopify:section:load', initAllMultibuyOffers);
  document.addEventListener('click', handleOptionClick);
  document.addEventListener('change', handleVariantChange);
})();
